import { ConnectProto } from "@racoon/api";

/** RouteCreate fields for a new, empty trip on a shift that departs and unloads where `like` does. */
export const tripLike = (
  like: ConnectProto.Route,
  driverOnShiftId: bigint,
  ownerOrganizationId: bigint,
) => ({
  ownerOrganizationId,
  driverOnShiftId,
  sourceLon: like.sourceLon ?? 0,
  sourceLat: like.sourceLat ?? 0,
  destinationLon: like.destinationLon ?? 0,
  destinationLat: like.destinationLat ?? 0,
  destinationLocationId: like.destinationLocationId
    ? BigInt(like.destinationLocationId)
    : undefined,
  sourceLocationId: like.sourceLocationId ? BigInt(like.sourceLocationId) : undefined,
  routeCategory: like.routeCategory,
});
